

'use strict';



export default function fixElementTop (elem) {
    const header = document.querySelector('#header');
    const headerHeight = header ? header.getBoundingClientRect().bottom : 0;

    if ( elem ) {
        elem.style.top = headerHeight + 'px';
    }
}
